import React from 'react';

import {Icon} from '@chakra-ui/react';
import {MdHome, MdLocalHospital, MdPerson,} from 'react-icons/md';
import DashboardContent from "./components/dashboardComponents/DashboardContent.tsx";
import UserList from "./dashboardPages/UserList";
import PatientList from "./dashboardPages/PatientList";

const routes = [
    {
        name: 'Main Dashboard',
        layout: '/admin',
        path: '/dashboard',
        icon: <Icon as={MdHome} width="25px" height="25px" color="inherit"/>,
        component: <DashboardContent/>,
    },
    {
        name: 'Doctors',
        layout: '/admin',
        path: '/doctors',
        icon: <Icon as={MdLocalHospital} width="25px" height="25px" color="inherit"/>,
        component: <UserList/>,
        secondary: true,
    },
    {
        name: 'Patients',
        layout: '/admin',
        icon: <Icon as={MdPerson} width="25px" height="25px" color="inherit"/>,
        path: '/patients',
        component: <PatientList/>,
    },
];

export default routes;
